let mapper_options = {
  endpoint: 'communications',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      campaign: {
        foreignKey: 'campaign_id',
        localField: 'campaign'
      }
    },
    hasMany: {
      communication_automation: {
        foreignKey: 'communication_id',
        localField: 'communication_automations'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('communication', mapper_options)
}
